import React from 'react'
import capitalize from 'lodash/capitalize'
import { Button, Card, Header } from '@lightspeed/design-system-react'
import { T, UT } from '@transifex/react'
import { getDisplayNameFromApiCustomer } from '@vend/react-utilities'
import { useRepeatPaymentMethodRequests } from '../payment-panel/PaymentRequest/hooks/useRepeatPaymentMethodRequests'
import { getFeatureFromCache } from '../../../util/feature-cache'
import {
  useUserManager,
  useWebRegisterStatusManager,
} from '../../../ng-compat/hooks'
import { PERMISSIONS } from '../../../constants/permissions'
import { useAppSelector } from '../../../state/hooks'
import { selectCustomer } from '../../../state/slices/currentSale/currentSaleSlice'
import { selectTrainingModeEnabled } from '../../../state/slices/posState/posStateSlice'
import { isValidCustomer } from '../../../functions/sale'

export const RepeatPaymentMethodSave: React.FC = () => {
  const customer = useAppSelector(selectCustomer)
  const isTrainingMode = useAppSelector(selectTrainingModeEnabled)
  const userManager = useUserManager()
  const webRegisterStatusManager = useWebRegisterStatusManager()

  const featureFlagEnabled =
    getFeatureFromCache('enable_customer_saved_cards') &&
    getFeatureFromCache('lspay_show_repeat_card_detection')
  const userPermissionGranted = userManager?.hasPermission(
    PERMISSIONS.LSPAY_PMOF_ADD_EDIT_USE
  )

  const enabled =
    Boolean(featureFlagEnabled && userPermissionGranted) &&
    !isTrainingMode &&
    webRegisterStatusManager?.isOnline() &&
    isValidCustomer(customer)

  const {
    data: repeatPaymentMethodData,
    isLoading: isLoadingRepeatPaymentMethod,
  } = useRepeatPaymentMethodRequests(enabled)

  // only render when
  // register is live, repeat card feature is enabled,
  // api response data is available,
  // card has repeated and isn't already saved
  if (
    !enabled ||
    isLoadingRepeatPaymentMethod ||
    !repeatPaymentMethodData ||
    repeatPaymentMethodData.repeatCardOccurrenceCount < 2 ||
    repeatPaymentMethodData.isSaved
  ) {
    return null
  }

  const handleSaveCard = () => {
    // TODO: Implement save card functionality
  }

  const handleDontAskAgain = () => {
    // TODO: Implement don't ask again functionality
  }

  const customerName = customer
    ? getDisplayNameFromApiCustomer(customer)
    : 'This customer'

  const brand = repeatPaymentMethodData.brand
    ? capitalize(repeatPaymentMethodData.brand)
    : 'Card'
  const last4 = repeatPaymentMethodData.last4 || '****'

  return (
    <Card className="vd-mt10" data-testid="repeat-payment-method-card">
      <div className="vd-pa5" style={{ textAlign: 'left' }}>
        <Header type="sub-heading" level="3" className="vd-mb3">
          <T _str="Save card for {customerName}?" customerName={customerName} />
        </Header>
        <div className="vd-mb4">
          <UT
            _str="{customerName} has used {brand} ••••{last4} several times here before. Save it for faster checkouts on future purchases."
            customerName={customerName}
            brand={brand}
            last4={last4}
          />
        </div>
        <div className="vd-btn-group">
          <Button onClick={handleSaveCard} variant="supplementary">
            <T _str="Save card" />
          </Button>
          <Button onClick={handleDontAskAgain} variant="no" modifier="icon">
            <T _str="Don't ask again for this card" />
          </Button>
        </div>
      </div>
    </Card>
  )
}
